export const { SCHEME, API_URL, WEB_URL, WEB_API_URL, HELP_URL, BLOG_URL, PUBLICDOCS_URL, DOCS_URL, SENTRY_FRONTEND_DSN, SENTRY_ENV_NAME, GOOGLE_REDIRECT_URI_IDENTITY, GOOGLE_CLIENT_ID, SITE_KEY, FEATURE_ENABLED, OIDC_AUTHORITY, OIDC_CLIENT_ROOT, OIDC_CLIENT_ID, STRIPE_KEY, CLARITY_KEY, GOOGLE_TAG_MANAGER_KEY, MICROSOFT_CLIENT_ID, MICROSOFT_REDIRECT_URI_IDENTITY, } = window.__RUNTIME_CONFIG__;
export const WEB_URL_FULL = `${SCHEME}://${WEB_URL}`;
export const PUBLICDOCS_URL_FULL = `${SCHEME}://${PUBLICDOCS_URL}`;
export const DOCS_URL_FULL = `${SCHEME}://${DOCS_URL}`;
export const HELP_URL_FULL = `${SCHEME}://${HELP_URL}`;
export const WEB_API_URL_FULL = `${SCHEME}://${WEB_API_URL}`;
export const API_VERSION_PREFIX = '/api/v1';
export const API_PREFIX = `${SCHEME}://${API_URL}`;
//STATIC URLS
export const FACEBOOK_URL = "https://www.facebook.com/banafocom";
export const X_URL = "https://x.com/banafo_com";
export const LINKEDIN_URL = "https://www.linkedin.com/company/banafo";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.banafo.app";
export const DOWNLOAD_ZOIPER_APP_URL = "https://www.zoiper.com/en/voip-softphone/download/current";
//RTK QUERY
export const RTK_REQUEST_STATUS_PENDING = 'pending';
export const RTK_REQUEST_STATUS_FULFILLED = 'fulfilled';
export const RTK_REQUEST_STATUS_REJECTED = 'rejected';
//CONFIGS
export const DEBUG = false;
export const LANGUAGE_EN_US = 'en-US';
export const SORT_ASC = 1;
export const SORT_DESC = -1;
